export interface IFilterSliderConstant {
  marks: { value: number; label: string }[];
  min: number;
  max: number;
  minDistance: number;
  prefix: string;
}

export interface IFilterSliderConstants {
  engineOutputInPs: IFilterSliderConstant;
  operationTime: IFilterSliderConstant;
  medianPrice: IFilterSliderConstant;
  price: IFilterSliderConstant;
}

export const filterSliderConstant: IFilterSliderConstants = {
  engineOutputInPs: {
    marks: [
      {
        value: 0,
        label: '',
      },
      {
        value: 50,
        label: '',
      },
      {
        value: 100,
        label: '',
      },
      {
        value: 150,
        label: '',
      },
      {
        value: 200,
        label: '',
      },
      {
        value: 250,
        label: '',
      },
      {
        value: 300,
        label: '',
      },
    ],
    min: 0,
    max: 300,
    minDistance: 50,
    prefix: '마력',
  },
  operationTime: {
    marks: [
      {
        value: 0,
        label: '',
      },
      {
        value: 1000,
        label: '',
      },
      {
        value: 2000,
        label: '',
      },
      {
        value: 3000,
        label: '',
      },
      {
        value: 4000,
        label: '',
      },
      {
        value: 5000,
        label: '',
      },
      {
        value: 6000,
        label: '',
      },
      {
        value: 7000,
        label: '',
      },
      {
        value: 8000,
        label: '',
      },
      {
        value: 9000,
        label: '',
      },
      {
        value: 10000,
        label: '',
      },
    ],
    min: 0,
    max: 10000,
    minDistance: 1000,
    prefix: '시간',
  },
  medianPrice: {
    marks: [
      {
        value: 0,
        label: '',
      },
      {
        value: 1,
        label: '',
      },
      {
        value: 2,
        label: '',
      },
      {
        value: 3,
        label: '',
      },
      {
        value: 4,
        label: '',
      },
      {
        value: 5,
        label: '',
      },
      {
        value: 6,
        label: '',
      },
      {
        value: 7,
        label: '',
      },
      {
        value: 8,
        label: '',
      },
      {
        value: 9,
        label: '',
      },
      {
        value: 10,
        label: '',
      },
      {
        value: 11,
        label: '',
      },
      {
        value: 12,
        label: '',
      },
    ],
    min: 0,
    max: 12,
    minDistance: 1,
    prefix: '원',
  },
  price: {
    marks: [
      {
        value: 0,
        label: '',
      },
      {
        value: 1,
        label: '',
      },
      {
        value: 2,
        label: '',
      },
      {
        value: 3,
        label: '',
      },
      {
        value: 4,
        label: '',
      },
      {
        value: 5,
        label: '',
      },
      {
        value: 6,
        label: '',
      },
      {
        value: 7,
        label: '',
      },
      {
        value: 8,
        label: '',
      },
      {
        value: 9,
        label: '',
      },
      {
        value: 10,
        label: '',
      },
      {
        value: 11,
        label: '',
      },
      {
        value: 12,
        label: '',
      },
    ],
    min: 0,
    max: 12,
    minDistance: 1,
    prefix: '원',
  },
};

// 슬라이더 표시 값과 실제 값 사이의 매핑
export const priceSliderValueMapping: Record<number, number> = {
  0: 0,
  1: 10000000,
  2: 20000000,
  3: 30000000,
  4: 40000000,
  5: 50000000,
  6: 60000000,
  7: 70000000,
  8: 80000000,
  9: 90000000,
  10: 100000000,
  11: 200000000,
  12: 300000000,
};

export type PriceSliderValueMappingType = keyof typeof priceSliderValueMapping;
